import { c as _c } from "react/compiler-runtime";
import React from 'react';
import ShowroomLocatorContent from './ShowroomLocatorContent';
const DesktopShowroomLocator = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="w-[320px] lg:w-[350px] min-[1440px]:w-[400px] pl-4 pr-4 mt-1"><div className="text-gray mb-2 font-bold text-lg">Location</div><div className="text-sm text-gray mb-1">Find your closest showroom</div><ShowroomLocatorContent inputId="showroom-zipcode" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
DesktopShowroomLocator.propTypes = {};
export default DesktopShowroomLocator;